// extracted by mini-css-extract-plugin
module.exports = {"noImg":"NoImg-noImg-1ZOUK"};